import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import Router from './routes/Router.tsx';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';
import { GLOBAL_ERROR_MESSAGE } from './common/constants.ts';
import * as Sentry from '@sentry/react';
import { PeriodClosureProvider } from './context/PeriodClosureContext';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) =>
      toast.error(GLOBAL_ERROR_MESSAGE, {
        description: `Error: ${error.message}`,
        closeButton: true,
      }),
  }),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <PeriodClosureProvider>
        <>
          <RouterProvider router={Router} />
          <Toaster />
        </>
      </PeriodClosureProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
